// The store's COD form, read once per checkout render; a failed read never blocks the sale.
import { DEFAULT_COD_FORM_CONFIG, type CodFormConfig } from '@xshop/shared';
import { fetchApi } from './client';
import { isThemeEditor } from '../editor/editorVisit';

// Fetches the merchant's configured checkout form, falling back to the platform default. In the website builder it is
// read fresh, past every cache: its Order form panel saves the form's look and reloads the preview to show it, and the
// minute a shopper's copy is cached for would show the merchant their previous change.
export async function getCodFormConfig(): Promise<CodFormConfig> {
  try {
    if (isThemeEditor()) return await fetchApi<CodFormConfig>(`/cod-form?fresh=${Date.now()}`, { cache: 'no-store' });
    return await fetchApi<CodFormConfig>('/cod-form');
  } catch (error) {
    console.warn('COD form configuration unavailable, using the default form:', error);
    return DEFAULT_COD_FORM_CONFIG;
  }
}
